<template>
  <div>
    <Breadcrumbs :aditionalItems="marksheetDetailLink" class="pa-2" head="Bảng điểm tổng kết"></Breadcrumbs>
    <v-card v-if="marksheetData">
      <v-card-title>
        <span class="">{{ marksheetData.title }}</span>
        <template v-if="canEdit">
          <v-btn class="ml-1" small icon @click="onClickUpsertMarkSheet(marksheetData)">
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          <v-btn small icon @click="onClickDeleteMarkSheet(marksheetData)">
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
          <div class="flex-fill"></div>
          <v-btn :to="`./${!isContentRoute ? 'content' : 'config'}`" color="primary" elevation="0">
            {{ !isContentRoute ? 'Nội dung' : 'Cấu hình' }}
            <v-icon right>mdi-{{ !isContentRoute ? 'file-document-outline' : 'tune' }}</v-icon>
          </v-btn>
        </template>
      </v-card-title>
      <v-card-text class="pb-0"> Nhóm lớp: {{ studentGroupsText }} </v-card-text>
      <v-card-text>
        <!-- <v-tabs v-model="tabIndex" class="mb-3">
          <v-tab to="config">Cấu hình</v-tab>
          <v-tab to="content">Nội dung</v-tab>
        </v-tabs> -->
        <router-view></router-view>
      </v-card-text>
    </v-card>
    <BaseDialog
      v-if="upsertMarkSheetDialog.isOpen"
      :isOpen="upsertMarkSheetDialog.isOpen"
      :title="upsertMarkSheetDialog.title"
      @close="upsertMarkSheetDialog.isOpen = false"
      @cancel="upsertMarkSheetDialog.onCancel"
      @confirm="upsertMarkSheetDialog.callback"
    >
      <v-form
        lazy-validation
        ref="upsertMarkSheetDialog"
        @submit.prevent="upsertMarkSheetDialog.callback()"
      >
        <v-card-text>
          <v-text-field
            autofocus
            label="Tiêu đề"
            v-model="upsertMarkSheetDialog.currentItem.title"
          ></v-text-field>
          <v-autocomplete
            item-text="text"
            :items="studentGroups"
            item-value="id"
            multiple
            v-model="upsertMarkSheetDialog.currentItem.student_groups"
            :rules="[$rules.required, $rules.minArrayLength(1)]"
            label="Nhóm lớp"
          >
          </v-autocomplete> </v-card-text
      ></v-form>
    </BaseDialog>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/basic/Breadcrumbs.vue'
import { mapActions, mapState } from 'vuex'
import { cloneDeep, isEqual } from 'lodash'
import BaseDialog from '@/components/base/BaseDialog'

export default {
  components: {
    BaseDialog,
    Breadcrumbs
  },
  data() {
    return {
      tabIndex: 0,
      upsertMarkSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.upsertMarkSheetDialog.isOpen = false
        },
        callback: () => {}
      },
      upsertSemesterConfigDialog: {
        isOpen: false,
        title: '',
        currentItem: null,
        callback: null,
        onCancel: () => {
          this.upsertSemesterConfigDialog.isOpen = false
        }
      }
    }
  },
  methods: {
    ...mapActions('marksheet', [
      'fetchOverallMarkSheet',
      'fetchSemesterConfigs',
      'createSemesterConfig',
      'updateSemesterConfig',
      'updateOverallMarkSheet',
      'createOverallMarkSheet',
      'fetchOverallMarkSheetContent',
      'removeOverallMarkSheet'
    ]),
    ...mapActions('studentGroup', ['fetchStudentGroups']),
    onClickDeleteMarkSheet(item) {
      this.$dialog.confirm({
        title: 'Xóa bảng điểm',
        text: ` Bạn có Chắc Chắn xóa bảng điểm và các thông tin liên quan?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeOverallMarkSheet(item.id)
          this.$alert.success('Xóa thành công')
          this.$router.push('/mark-sheets')
        }
      })
    },

    onClickUpsertMarkSheet(item) {
      this.upsertMarkSheetDialog.currentItem = cloneDeep(item) || {
        title: 'Bảng điểm số ' + (this.tableData.length + 1),
        student_groups: []
      }
      this.upsertMarkSheetDialog.title = item ? 'Sửa bảng điểm' : 'Tạo bảng điểm'
      this.upsertMarkSheetDialog.isOpen = true
      this.upsertMarkSheetDialog.callback = (async () => {
        try {
          if (item) {
            await this.updateOverallMarkSheet(this.upsertMarkSheetDialog.currentItem)
            this.$alert.success('Cập nhật thành công')
            if (
              !isEqual(
                (this.upsertMarkSheetDialog.currentItem || {}).student_groups || [],
                (item.student_groups || []).map(i => i.id)
              )
            ) {
              this.fetchOverallMarkSheetContent({ marksheetId: this.$route.params.id })
            }
          } else {
            await this.createOverallMarkSheet({ data: this.upsertMarkSheetDialog.currentItem })
            this.$alert.success('Tạo thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertMarkSheetDialog.isOpen = false
        }
      }).bind(this)
    },
    onClickUpsertSemester(item) {
      this.upsertSemesterConfigDialog.isOpen = true
      this.upsertSemesterConfigDialog.title = item ? 'Sửa cấu hình học kỳ' : 'Tạo học kỳ mới'
      this.upsertSemesterConfigDialog.currentItem = item
        ? cloneDeep(item)
        : {
            title: `Học kỳ ` + (this.semesterConfigs.length + 1),
            overall_mark_sheet: this.$route.params.id
          }
      this.upsertSemesterConfigDialog.callback = async () => {
        try {
          if (item) {
            await this.updateSemesterConfig(this.upsertSemesterConfigDialog.currentItem)
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createSemesterConfig({ data: this.upsertSemesterConfigDialog.currentItem })
            this.$alert.success('Tạo thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertSemesterConfigDialog.isOpen = false
        }
      }
    }
  },
  computed: {
    ...mapState('marksheet', ['overallMarkSheets', 'semesterConfigs', 'semesterCourseConfigs']),
    ...mapState('studentGroup', ['studentGroups']),
    ...mapState('auth', ['profile', 'role']),
    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },
    isContentRoute() {
      const currentRoute = this.$route
      return currentRoute.path.includes('content')
    },
    marksheetData() {
      return this.overallMarkSheets.find(i => i.id === this.$route.params.id)
    },
    marksheetDetailLink() {
      return [
        {
          to: `/mark-sheets/`,
          text: 'Bảng điểm tổng kết'
        },
        {
          to: `/mark-sheets/${this.$route.params.id}/`,
          text: (this.marksheetData || {}).title
        }
      ]
    },
    studentGroupsText() {
      if (!this.marksheetData) {
        return ''
      }
      return this.marksheetData.student_groups.map(i => i.text).join(', ')
    }
  },
  created() {
    this.fetchOverallMarkSheet({ marksheetId: this.$route.params.id })
    this.fetchSemesterConfigs({ marksheetId: this.$route.params.id })
    this.fetchStudentGroups()
  }
}
</script>
<style scoped>
.semester-configs {
  margin-bottom: 20px;
}
</style>
